import { common } from './common';
import { EnvironmentSettings } from './environment-interface';

export const environment: EnvironmentSettings = {
    ...common,
    envModules: [],
    production: false,
    name: 'qa',
    url: 'https://qa-hr.humi.ca',
    api: 'https://qa-api.humi.ca',
    payrollUrl: 'https://demo.payroll.humi.ca',
    stripeKey: 'pk_test_ifjlT2peLVylXoYuSzIbLGSI',
    sentry: 'https://f160c28cf8b14d3b8fe72424f852e601@sentry.io/302995',
    launchDarkly: '5db2eee6ae7a78085ac26d63',
    helloSignClientId: 'c09b9a9a99ee22bce344f56d4a4b6f06',
    pusher: {
        id: 919519,
        key: '5c130cb3e374014b5ea8',
        cluster: 'us2',
    },
    jobBoardDomain: 'applytojob.link',
    googleMapsApiKey: 'AIzaSyCAp3GjlzoLRngAFXCkELIPLgYwTuykapU',
    simplyBenefitsAdminPanelUrl: 'https://app-staging.simplybenefits.ca/admin/login',
    simplyBenefitsEmployeePortalUrl: 'https://member-staging.simplybenefits.ca/login',
    auth0: {
        domain: 'qa-account.humi.ca',
        clientId: 'HZFYl7P5r5hcOWvbEhHLaGrbeZQQ4NIE',
        authorizationParams: {
            audience: 'https://qa-api.humi.ca',
            redirect_uri: 'https://qa-hr.humi.ca/auth0callback',
        },
    },
};
